import script from "./EnvWatermark.vue?vue&type=script&setup=true&lang=js"
export * from "./EnvWatermark.vue?vue&type=script&setup=true&lang=js"

import "./EnvWatermark.vue?vue&type=style&index=0&id=13ed52fc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13ed52fc"]])

export default __exports__